import React from 'react';
import './TrustBar.css';

function TrustBar() {
  const technologies = [
    { name: 'AWS', logo: 'https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg', description: 'Amazon Web Services' },
    { name: 'Google Cloud', logo: 'https://www.marefa.org/w/images/thumb/5/51/Google_Cloud_logo.svg/640px-Google_Cloud_logo.svg.png', description: 'Google Cloud Platform' },
    { name: 'React', logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg', description: 'React JS' },
    { name: 'Laravel', logo: 'https://upload.wikimedia.org/wikipedia/commons/9/9a/Laravel.svg', description: 'Laravel Framework' },
    { name: 'PostgreSQL', logo: 'https://upload.wikimedia.org/wikipedia/commons/2/29/Postgresql_elephant.svg', description: 'PostgreSQL Database' },
    { name: 'Express', logo: 'https://upload.wikimedia.org/wikipedia/commons/6/64/Expressjs.png', description: 'Express.js Web Framework' },
    { name: 'Node.js', logo: 'https://upload.wikimedia.org/wikipedia/commons/d/d9/Node.js_logo.svg', description: 'Node.js Runtime' },
    { name: 'Docker', logo: 'https://www.vectorlogo.zone/logos/docker/docker-official.svg', description: 'Docker Containerization' },
    { name: 'MongoDB', logo: 'https://www.vectorlogo.zone/logos/mongodb/mongodb-ar21.svg', description: 'MongoDB NoSQL Database' },
    { name: 'Figma', logo: 'https://www.vectorlogo.zone/logos/figma/figma-icon.svg', description: 'Figma Design' },
    { name: 'Flutter', logo: 'https://www.vectorlogo.zone/logos/flutterio/flutterio-icon.svg', description: 'Flutter SDK' },
    { name: 'Claude', logo: 'https://cdn.freelogovectors.net/svg18/claude-logo-freelogovectors.net.svg', description: 'Anthropic Claude AI' },
  ];

  // Doubling the array for seamless infinite looping
  const displayTechs = [...technologies, ...technologies];

  return (
    <section className="trust-bar">
      <div className="trust-bar-overflow">
        <div className="trust-bar-track">
          {displayTechs.map((tech, index) => (
            <div key={index} className="trust-bar-item">
              <img
                src={tech.logo}
                alt={tech.name}
                className="trust-bar-logo"
                title={`${tech.name}: ${tech.description}`}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TrustBar;
